// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import { translate } from "../plugins/i18n";
import PhoneHelper from "./phoneHelper";

const phoneValidator = (rule: any, value: any, callback: (error?: Error) => void) => {
  if (value) {
    if (PhoneHelper.validate(value)) {
      callback();
    } else {
      callback(new Error(translate("Form.InvalidPhoneError")));
    }
  } else {
    callback();
  }
};

/**
 * Rule for required field
 * @returns {object} Rule for ElementUI form
 */
export const requiredRule = function () {
  return {
    required: true,
    message: translate("Form.RequiredFieldError"),
    trigger: "blur",
  };
};

/**
 * Rule for email field
 * @returns {object} Rule for ElementUI form
 */
export const emailRule = function () {
  return {
    type: "email",
    message: translate("Form.InvalidEmailError"),
    trigger: "blur",
  };
};

/**
 * Rule for phone field
 * @returns {object} Rule for ElementUI form
 */
export const phoneRule = function () {
  return {
    validator: phoneValidator,
    trigger: "blur",
  };
};
